import _dottedPathToPopulation from '@/shared/functions/population-helpers/_dottedPathToPopulation';
import standardTireDotPopulation from '@/shared/functions/population-helpers/standardTireDotPopulation';
import standardTirePopulation from '@/shared/functions/population-helpers/standardTirePopulation';

/**
 * Generate standard tire size population object for the given prefix
 *
 * @param path - The path to generate the population object for
 * @param options - The options for the population object
 * @returns The population object
 *
 * @example
 * // Returns {
 * //   'populate[tireSize]': 1,
 * //   'populate[tireSize][tire][brand]': 1,
 * //   'populate[tireSize][tire][certifiedBy]': 1,
 * //   'populate[tireSize][tire][euTireLabel]': 1,
 * //   'populate[tireSize][tireDot]': 1,
 * //   'populate[tireSize][tireDot][specialPrice]': 1,
 * // }
 * standardTireSizePopulation('tireSize.tire', { populateRoot: true, populateTireDot: true })
 */
export default function standardTireSizePopulation(
  path: string = '',
  {
    populateRoot = false,
    populateTireDot = true,
    populateTire = true,
  }: {
    /**
     * Whether to populate the current TireSize object itself
     */
    populateRoot?: boolean;
    /**
     * Whether to populate the TireSize[TireDot] object
     */
    populateTireDot?: boolean;
    /**
     * Whether to populate the TireSize[Tire] object
     */
    populateTire?: boolean;
  } = {}
) {
  const p = _dottedPathToPopulation(path);
  return {
    ...(populateRoot ? { [`populate${p}`]: 1 } : {}),
    [`populate${p}[mediaFiles]`]: 1,
    [`populate${p}[voucherPromotion]`]: 1,
    ...(populateTire ? standardTirePopulation(`${path}.tire`, { populateRoot: true }) : {}),
    ...(populateTireDot
      ? standardTireDotPopulation(`${path}.tireDot`, { populateRoot: true })
      : {}),
    ...(!populateTireDot ? { [`populate${p}[specialPrice]`]: 1 } : {}),
  };
}
